import * as React from 'react';
import { Fragment, useEffect } from 'react';
export var TabIndexBlocker = function (_a) {
    var children = _a.children;
    useEffect(function () {
        renameAttribute('[tabindex]', 'tabindex', getBackupAttributeName('tabindex'));
        return function () {
            renameAttribute("[" + getBackupAttributeName('tabindex') + "]", getBackupAttributeName('tabindex'), 'tabindex');
        };
    }, []);
    return React.createElement(Fragment, null, children);
};
function getBackupAttributeName(attr) {
    return "data-volley-" + attr;
}
function renameAttribute(selector, from, to) {
    document.querySelectorAll(selector).forEach(function (elem) {
        var val = elem.getAttribute(from);
        if (val !== null) {
            elem.setAttribute(to, val);
            elem.removeAttribute(from);
        }
    });
}
//# sourceMappingURL=TabIndexBlocker.js.map